import { useEffect, useState } from 'react';
import { RichText } from '@swordhealth/ui-corporate';
import { MarkdownRichText } from '@/app/_components/shared';
import { Container } from '@/components/ui/flexbox';
import { ACTIONS, trackButtonClicked } from '@/utils/track';

import { Wrapper, Inner, CustomParagraph, Button } from './styles';
import IconClose from '@/public/icons/ic_close.svg';

const trackLink = (target) => {
  if (!target) return null;
  trackButtonClicked({
    action: ACTIONS.REDIRECT_TO_DESTINATION,
    destination: target.href,
    buttonLocation: 'top-banner',
    buttonText: target.innerText,
  });
};

const TopBanner = ({ content }) => {
  const { title, backgroundGradient, closeAvailable } = content;
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const componentLinks = document.querySelectorAll('.top-banner-text a');

    const trackLinks = () => {
      componentLinks.forEach((link) => {
        link.addEventListener('click', () => trackLink(link));
      });
    };

    const cleanupLinks = () => {
      componentLinks.forEach((link) => {
        link.removeEventListener('click', () => trackLink(link));
      });
    };

    trackLinks();

    return () => {
      cleanupLinks();
    };
  }, []);

  if (!isVisible) return null;

  return (
    <Wrapper $gradient={backgroundGradient}>
      <Container>
        <Inner>
          <CustomParagraph as="div" size="md" $gradient={backgroundGradient}>
            <RichText>
              <MarkdownRichText className="top-banner-text" elements={['a', 'strong']}>
                {title}
              </MarkdownRichText>
            </RichText>
          </CustomParagraph>

          {closeAvailable && (
            <Button onClick={() => setIsVisible(false)} $gradient={backgroundGradient}>
              <IconClose />
            </Button>
          )}
        </Inner>
      </Container>
    </Wrapper>
  );
};

export default TopBanner;
